import { useTranslation } from "react-i18next";

import { DeliveryType } from "../../../constants";
import { DeliveriesTableAtomProps } from "../DeliveriesTable.types";

import styles from "../DeliveriesTable.module.scss";

export const OrderCell = ({ item }: DeliveriesTableAtomProps) => {
  const { t } = useTranslation();

  return (
    <>
      {item.type !== DeliveryType.Delivery && (
        <div className={styles.deliveries_returnLabel}>
          {item.type === DeliveryType.ReturnPickUpFromCustomer
            ? t("Return pick-up")
            : t("Return delivery")}
        </div>
      )}
      <div className={styles.deliveries_orderId}>{item.orderId}</div>

      <div className={styles.deliveries_orderAddress}>
        {`${item.recipientFullName} ${item.recipientAddress} ${item.recipientPhoneNumber}`}
      </div>
    </>
  );
};
